module.exports = __webpack_public_path__ + "static/img/AirTax-logo.468053a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AirTax-logo.png
// module id = g6ej
// module chunks = 34